import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewRef } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { InputLabelPipe } from '../../../../../pipes/atyl/inputLabel.pipe'
import { DialogService } from '../../../../../services'
import { ConfirmComponent } from '../../../../../views/partials/layout/dialogs/confirm-dialog/confirm.component'
import { FormAtylBase,ForAtylInputBase } from '../../../../form-atyl-base'
import { AtylService } from '../../../../service/atyl.service'
import { FormDialogSecteurComponent } from '../../../form-dialog/form-dialog-secteur/form-dialog-secteur.component'

@Component({
	selector: 'atyl-form-input-adresse',
	templateUrl: './form-input-adresse.component.html',
	styleUrls: ['./form-input-adresse.component.scss']
})
export class FormInputAdresseComponent extends ForAtylInputBase implements OnInit, OnChanges {

	@Input() forminput: FormAtylBase<any>
	@Input() group: FormGroup
	@Input() isValid: boolean
	@Input() errorMessage: any
	@Input() outline: any
	@Input() disabled: boolean
	init = true;
	checkSecteur = 'row'

	
	@Output() inputTyped = new EventEmitter<any>()
	label: string
	errorString: string
	filteredOptionsCode: any
	filteredOptionsVille: any
	filteredOptionsRue: any
	shareAdresseWith: any
	private ville = ''
	private codepost = ''
   IsCheckedHorsDep:boolean=false;
   IsCheckedSameAdress:string=null;
   
	constructor(
		private readonly atylService: AtylService,
		private readonly cdr: ChangeDetectorRef,
		private readonly dialogService: DialogService,
		private readonly inputLabelPipe: InputLabelPipe
	) { 
		
		super();
	}


	ngOnInit(): void {
		this.emitReadyEvent(false,this.forminput);
		
		this.label = this.inputLabelPipe.transform(this.forminput)
		this.errorString = this.errorMessage && this.errorMessage[0] ? this.errorMessage[0] : ''
		this.manageHsitorique()
	}
	customBehaviourHandler(customBehaviour: any) {
		this.inputTyped.emit(customBehaviour)
	}
	ngOnChanges() {
		this.__track__changes__()
	}
	private __track__changes__() {

		if (this.group.get(this.forminput.ID) !== undefined
			&& this.group.get(this.forminput.ID).get('adresse') !== undefined
			&& this.group.get(this.forminput.ID).get('adresse')
		)
			this.group.get(this.forminput.ID).get('adresse').enable()
		if (this.group.get(this.forminput.ID) !== undefined
			&& this.group.get(this.forminput.ID).get('adresse2') !== undefined
			&& this.group.get(this.forminput.ID).get('adresse2')
		)
			this.group.get(this.forminput.ID).get('adresse2').enable()
       if (this.group.get(this.forminput.ID) !== undefined
			&& this.group.get(this.forminput.ID).get('horsdep') !== undefined
			&& this.group.get(this.forminput.ID).get('horsdep')
		)
             this.group.get(this.forminput.ID).get('horsdep').enable()
       
       if (this.group.get(this.forminput.ID) !== undefined
			&& this.group.get(this.forminput.ID).get('same_address') !== undefined
			)
              this.group.get(this.forminput.ID).get('same_address').enable()
                  
		if (this.forminput.value) {
			if (this.forminput.value['code'])
				this.codepost = this.forminput.value['code']
			if (this.forminput.value['ville'])
				this.ville = this.forminput.value['ville']
			if (this.forminput.value['adresse'])
				this.group.get(this.forminput.ID).get('adresse').setValue(this.forminput.value['adresse'].toUpperCase())
			if (this.forminput.value['adresse2'])
				this.group.get(this.forminput.ID).get('adresse2').setValue(this.forminput.value['adresse2'].toUpperCase())
		    if (this.forminput.value['horsdep'])
				this.IsCheckedHorsDep=true;
			 if (this.forminput.value['same_address']
			  && this.forminput.value['same_address']=='1' ) {
				this.IsCheckedSameAdress="checked";	
				this.group.get(this.forminput.ID).get('same_address').setValue(1);
			}	
			console.log("FormInputAdresseComponent init value",this.IsCheckedHorsDep,
			this.forminput.value)
				
		    this.cdr.detectChanges()
		}
		this.atylService.getCodePostal(this.codepost).subscribe((result: JSONRpcResponse) => {
			this.filteredOptionsCode = result.result
			if (this.forminput.value && this.forminput.value['code'])
				this.group.get(this.forminput.ID).get('code').setValue(this.codepost)
		})
		this.__villes__()
	}
	private __villes__() {
		this.atylService.getVilles('').subscribe((result: JSONRpcResponse) => {
			this.filteredOptionsVille = result.result
			if (this.forminput.value && this.forminput.value['ville']) {
				this.group.get(this.forminput.ID).get('ville').setValue(this.ville)

				this.group.get(this.forminput.ID).get('num').enable()
				this.group.get(this.forminput.ID).get('comp').enable()
				this.group.get(this.forminput.ID).get('rue').enable()
				if (this.forminput.value && this.forminput.value['ville']) {
					this.getRuesByVille(this.forminput.value['ville'], this.forminput.ID)
					this.group.get(this.forminput.ID).get('num').setValue(this.forminput.value['num'])
					if (this.forminput.value['comp'])
						this.group.get(this.forminput.ID).get('comp').setValue(this.forminput.value['comp'].toUpperCase())
				}
			}
			
			this.emitReadyEvent(true,this.forminput);
		})
	}
	triggerSelectCodePost(zip: any) {
		this.atylService.getCodePostal(zip).subscribe((result: JSONRpcResponse) => {
			this.filteredOptionsCode = result.result
			this.cdr.detectChanges()
		})
	}
	getVilleByCP(id: any, nameinput: string) {
		this.atylService.getVillesByCP(id).subscribe((result) => {
			this.filteredOptionsVille = result.result
			if (this.init && this.forminput.value && this.forminput.value['ville']) {
				(this.group.controls[nameinput] as FormGroup).controls['ville'].setValue(this.forminput.value['ville'])
				if (!this.forminput.value['rue'])
					this.init = false
			}
			else {
				if(this.filteredOptionsVille.length == 1){
					(this.group.controls[nameinput] as FormGroup).controls['ville'].patchValue(this.filteredOptionsVille[0].id);
					this.group.get(this.forminput.ID).get('num').enable();
					this.group.get(this.forminput.ID).get('comp').enable();
					this.group.get(this.forminput.ID).get('rue').enable();
				}
				//Vérifie si la ville saisie correpond au cp séléctionné
				var villeConfirm = this.filteredOptionsVille.find(
					ville => ville.id == (this.group.controls[nameinput] as FormGroup).controls['ville'].value
				)
				if(!villeConfirm){
					(this.group.controls[nameinput] as FormGroup).controls['ville'].patchValue(null);
					(this.group.controls[nameinput] as FormGroup).controls['rue'].patchValue(null)
				}
			}
		})
	}
	getRuesByVille(villeid: any, nameinput: string) {
		if (villeid) {
			this.emitReadyEvent(false,this.forminput);
			this.atylService.getRueByVille(villeid).subscribe((result: JSONRpcResponse) => {
				this.filteredOptionsRue = result.result[0].rues
				if (this.init && this.forminput.value && this.forminput.value['rue']) {
					(this.group.controls[nameinput] as FormGroup).controls['rue'].setValue(this.forminput.value['rue'])
					this.cdr.detectChanges()
				}
				else
					(this.group.controls[nameinput] as FormGroup).controls['rue'].patchValue(null);
				(this.group.controls[nameinput] as FormGroup).controls['num'].enable();
				(this.group.controls[nameinput] as FormGroup).controls['comp'].enable();
				(this.group.controls[nameinput] as FormGroup).controls['rue'].enable()
				this.emitReadyEvent(true,this.forminput);
			})
		}
	}
	triggerSelectVille(ville: any, nameinput: string) {
		(this.group.controls[nameinput] as FormGroup).controls['num'].disable();
		(this.group.controls[nameinput] as FormGroup).controls['comp'].disable();
		(this.group.controls[nameinput] as FormGroup).controls['rue'].disable()
		this.atylService.getVilles(ville).subscribe((result) => {
			this.filteredOptionsVille = result.result
			this.cdr.detectChanges()
		})
	}

	getCPbyVille(ville: any, nameinput: string) {
		this.filteredOptionsVille.forEach((element: any) => {
			if (element.id === ville) {
				if (Array.isArray(this.filteredOptionsCode)) {
					this.filteredOptionsCode = this.filteredOptionsCode.filter(cp => {
						return element.codepostals.some(codepostal => codepostal.id === cp.ID);
					});
				}
				(this.group.controls[nameinput] as FormGroup).controls['code'].setValue(element.codepostals[0].id);
				(this.group.controls[nameinput] as FormGroup).controls['num'].enable();
				(this.group.controls[nameinput] as FormGroup).controls['comp'].enable();
				(this.group.controls[nameinput] as FormGroup).controls['rue'].enable()
				this.getRuesByVille(ville, nameinput)
			}
		})
	}

	displayAutoVille(villeid?: any): string | undefined {
		let villeselected: any | undefined
		if (this.filteredOptionsVille) {
			this.filteredOptionsVille.forEach((ville: any) => {
				if (ville.id === villeid) {
					villeselected = ville
				}
			})
		}
		return villeselected ? villeselected.libelle : undefined
	}

	triggerSelectRue(rue: any, nameinput: string) {
		this.atylService.getRues(rue, (this.group.controls[nameinput] as FormGroup).controls['ville'].value).subscribe((result) => {
			this.filteredOptionsRue = result.result
			this.cdr.detectChanges()
		})
	}

	displayAutoRue(rueid?: any): string | undefined {
		let rueselected
		if (this.filteredOptionsRue) {
			this.filteredOptionsRue.forEach((rue: any) => {
				if (rue.id === rueid) {
					rueselected = rue
				}
			})
		}
		return rueselected ? rueselected.libelle : undefined
	}

	dialogSecteur(nameinput: any, event: any) {
		const dialogRefSec =this.dialogService.open(FormDialogSecteurComponent, {
			data: {
				'name': nameinput,
				 "group": this.group,
				'controls': (this.group.controls[nameinput] as FormGroup).controls
			},
			draggable: true,
			width: '30wv'
		})
		
		dialogRefSec.afterClosed().subscribe(result => {
		if (result!=undefined) {  
	        this.checkSecteur = result;
	        console.log("dialogSecteur closed",result)
	        this.group.get(this.forminput.ID).get("zones").setValue(result);
	        this.cdr.detectChanges();
	        }
      });
		return false
	}
	setToHorsDept(value: any) {
		if (value.checked) {
			this.atylService.getVilles('HORS DEPARTEMENT').subscribe((result: JSONRpcResponse) => {
				if (result.result.length > 0) {
					this.group.get(this.forminput.ID).get('ville').setValue(result.result[0].id)
					this.group.get(this.forminput.ID).get('code').setValue('')
					this.group.get(this.forminput.ID).get('code').disable()
					this.group.get(this.forminput.ID).get('num').disable()
					this.group.get(this.forminput.ID).get('comp').disable()
					this.group.get(this.forminput.ID).get('rue').disable()
					this.group.get(this.forminput.ID).get('adresse').enable()
					this.group.get(this.forminput.ID).get('adresse2').enable()
					
				}
			})
		}
		else {
			this.group.get(this.forminput.ID).get('ville').setValue('')
			this.group.get(this.forminput.ID).get('code').setValue('')
			this.group.get(this.forminput.ID).get('code').enable()
			this.group.get(this.forminput.ID).get('num').enable()
			this.group.get(this.forminput.ID).get('comp').enable()
			this.group.get(this.forminput.ID).get('rue').enable()
			this.group.get(this.forminput.ID).get('adresse').enable()
			this.group.get(this.forminput.ID).get('adresse2').enable()
			

		}
	}
	setToUpper(newObj: any, sousElem?: any) {
		if (sousElem) {
			console.log("addresse setToUpper",sousElem,this.forminput.ID,newObj);
			this.group.get(String(this.forminput.ID)).get(sousElem).setValue(newObj.target.value.toUpperCase())
		}
		else {
			this.group.get(String(this.forminput.ID)).setValue(newObj.target.value.toUpperCase())
		}
	}

	manageHsitorique() {
	}

	manageSharedAdresse(event: any) {
		this.shareAdresseWith = event
		setTimeout(() => {
			if (this.cdr && !(this.cdr as ViewRef).destroyed) {
				this.cdr.detectChanges()
			}
		})
		this.group.get(this.forminput.ID).setValue({
			shared: true,
			tiersId: event.ID
		})
	}
	removeShared(event: any) {
		this.dialogService.open(ConfirmComponent, {
			draggable: true,
			width: '25vw',
			disableClose: false
		}, (result: any) => {
			if (result) {
				this.shareAdresseWith = null
			}
		})
	}
	
	CheckedSameAdress(event:any) {
		console.log("CheckedSameAdress", event);
		this.IsCheckedSameAdress="checked";	
		this.group.get(this.forminput.ID).get('same_address').setValue(1);
	}
}
